import { saveAnswer } from "../api";
export const saveAnswerAction = async (
  userID,
  assignmentID,
  questionID,
  grade,
  studentAnswer,
  setUser,
  testResults
) => {
  try {
    const res = await saveAnswer(
      userID,
      assignmentID,
      questionID,
      grade,
      studentAnswer,
      testResults
    );
    setUser(res.data);
  } catch (err) {
    console.log(err);
  }
};
